import { Text } from '@shared/components';
import DropdownMenu from '@shared/components/dropdown-menu/DropdownMenu';
import {
  FILTER_MENU_COMPACT_CLASS_NAME,
  FILTER_MENU_CONTENT_CLASS_NAME,
  FILTER_ROW_CLASS_NAME,
} from '@shared/features/data-table-filters/classNames';
import { DropdownMenuItem } from '@shared/features/data-table-filters/components';
import { DropdownFilterOption } from '@shared/features/data-table-filters/types';
import { DropdownQueryParam } from 'clerk_common/constants/urls/queryParams';
import clsx from 'clsx';
import { useState } from 'react';
import { PiCaretDown, PiCheck } from 'react-icons/pi';
import {
  CHAT_SCOPE_OPTIONS,
  ChatScope,
  getChatScopeLabel,
} from '../utils/chatScope';

export function ChatScopeMenu({
  onScopeChange,
  participantCount,
  participantFilterOption,
  scope,
}: {
  onScopeChange: (scope: Exclude<ChatScope, 'custom'>) => void;
  participantCount: number;
  participantFilterOption: DropdownFilterOption;
  scope: ChatScope;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <button
          type="button"
          aria-label="Chat scope"
          className="flex items-center gap-1 rounded-md px-2 py-1 transition-colors hover:bg-gray-100"
        >
          <Text type="body-sm" as="span" className="text-gray-700">
            {getChatScopeLabel(scope, participantCount)}
          </Text>
          <PiCaretDown size={12} className="text-gray-500" aria-hidden />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        align="start"
        className={clsx(
          FILTER_MENU_CONTENT_CLASS_NAME,
          FILTER_MENU_COMPACT_CLASS_NAME
        )}
      >
        {CHAT_SCOPE_OPTIONS.map((option) => (
          <DropdownMenu.Item
            key={option.value}
            className={FILTER_ROW_CLASS_NAME}
            onSelect={() => onScopeChange(option.value)}
          >
            <Text>{option.label}</Text>
            {option.value === scope && <PiCheck size={14} aria-hidden />}
          </DropdownMenu.Item>
        ))}
        <div className="h-px bg-gray-200" />
        <DropdownMenuItem
          options={participantFilterOption}
          type={DropdownQueryParam.USER_ID}
          showSearch
          open={isOpen}
          setOpen={setIsOpen}
        />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
